module.exports = __webpack_public_path__ + "static/media/vp.b202ee49.jpg";